import { render } from "./GoToTopButton.vue?vue&type=template&id=67725bb6&scoped=true"
import script from "./GoToTopButton.vue?vue&type=script&lang=js"
export * from "./GoToTopButton.vue?vue&type=script&lang=js"

import "./GoToTopButton.vue?vue&type=style&index=0&id=67725bb6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67725bb6"]])

export default __exports__